import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ssoLogin } from '@chegg/one-auth-sdk';
import { createLoginThunk, sdkLoginReducers } from "./sdkLogin";
import { recordEvents, EventTypes } from "../../utils/newRelicEvents";
export var sdkSsoLogin = createLoginThunk('sdkSsoLogin', async function (state, actionParams) {
  var clientId = state.clientId;
  recordEvents(_defineProperty({}, EventTypes.ssoLoginSent, {
    clientId: clientId,
    authType: actionParams.provider
  }));
  var provider = actionParams.provider;
  await ssoLogin(provider, actionParams.email, actionParams.token);
});
export var sdkSsoLoginReducers = {
  pending: function pending(state, action) {
    sdkLoginReducers.pending(state, action);
    //@ts-ignore
    var _action$meta$arg = action.meta.arg,
      provider = _action$meta$arg.provider,
      token = _action$meta$arg.token,
      email = _action$meta$arg.email,
      firstName = _action$meta$arg.firstName,
      lastName = _action$meta$arg.lastName;
    state.sso.email = email;
    state.sso.authProvider = provider;
    state.sso.authProviderToken = token;
    if (provider === 'apple' && firstName) {
      state.sso.firstName = firstName;
    }
    if (provider === 'apple' && lastName) {
      state.sso.lastName = lastName;
    }
  }
};